export class UpdateCartRequestPayload {
  /**
   * @param {Object} options
   * @param {string} options.sku
   * @param {string} options.name
   * @param {string} options.quantity
   */
  constructor({ sku, name, quantity }) {
    this.sku = sku
    this.name = name
    this.quantity = quantity
  }

  /**
   * Convert to a plain object suitable for JSON.stringify()
   */
  toJSON() {
    return {
      sku: this.sku,
      name: this.name,
      quantity: this.quantity,
    }
  }
}
